var pageMap = {
    "app": "ESA Landing Page",
    "callback": "CIP Authenticated Callback Page",
    "download": "Display User Information Page",
    "downloadInitiated": "Downloading Profile in-progress Page",
    "list": "List ICCIDs Page",
    "userInfo": "Fetching User details",  
    "accountError": "Account Issue Page",
    "DOWNLOAD_ERROR": "Technical issue while downloading",
    "TROUBLESHOOT_ERROR": "Technical issue while fetching userdetails",
    "ROUTE_ERROR": "Technical issue in Routing"    
};

module.exports = {
    initiateDigitalData: function () {
        window.digitalData = {
            page: {
                pageInfo: {
                    pageName: ''
                }
            },
            category: {
                primaryCategory: 'e-sim support'
            },
            errorMessage: []
        };
        return '';
    },
    updateDigitalData: function (pgeName, errorType) {
        // console.error("Page Name is "+ pgeName + " => Error Type is : " + errorType);
        var errorMessage = '';
        var errorCategory = '';
        if(pgeName.indexOf('error') !== -1) {
            pgeName = pageMap[errorType];
            if(errorType === 'TDI_LINK_ERROR') {
                errorMessage = "Business";
            } else {
                errorMessage = "Technical";
            }
            errorCategory = errorType;
        } else {
            pgeName = pageMap[pgeName];
        }
        // console.error("New Page Name is "+ pgeName + " Error Category: " + errorCategory + " ErrorType: " + errorMessage);
        window.digitalData = {
            page: {
                pageInfo: {
                    pageName: pgeName
                }
            },
            category: {
                primaryCategory: 'e-sim support'
            },
            errorMessage: [
                {
                    errorCode: errorCategory,
                    type: errorMessage
                }
            ]
        };

        return pgeName;
    }
}



// WEBPACK FOOTER //
// ./src/analytics/omintrack.js